import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-apresentacao',
  templateUrl: './apresentacao.component.html',
  styleUrls: ['./apresentacao.component.scss']
})
export class ApresentacaoComponent implements OnInit {
  @Input() nomecliente: string;
  @Input() telefone: string;
  @Input() cpf: string;  
  @Input() endereco: string;
  @Input() showEndereco: boolean;

  constructor( private router: Router) {}
  ngOnInit() {}

  editardados()
  {
    this.router.navigate(['/app/devedor/editar']);
  }
}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/components/apresentacao/apresentacao.component.ts